import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import PressForm from "../_components/PressForm";
import styles from "../Notice.module.css";
import apiService from "../../../../services/api";

export default function FormClient() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id'); // 수정 모드인지 확인
    const [pressData, setPressData] = useState(null);
    const [loading, setLoading] = useState(false);
    
    // 수정 모드일 때 기존 데이터 가져오기
    useEffect(() => {
        if (id) {
            const fetchPressData = async () => {
                setLoading(true);
                try {
                    const response = await apiService.getPressById(id);
                    setPressData(response);
                } catch (error) {
                    console.error('언론보도 데이터 가져오기 실패:', error);
                    alert('언론보도 정보를 가져오는데 실패했습니다.');
                    navigate("/admin/notices");
                } finally {
                    setLoading(false);
                }
            };
            
            fetchPressData();
        }
    }, [id, navigate]);
    
    const handleSubmit = () => {
        // 성공 후 언론보도 탭으로 돌아가기
        navigate("/admin/notices?tab=press");
    };
    
    const handleCancel = () => {
        // 취소 시 언론보도 탭으로 돌아가기
        navigate("/admin/notices?tab=press");
    };

    if (loading) {
        return (
            <div className={styles.noticeWrap}>
                <div className={styles.SubPageWidth}>
                    <div className={styles.header}>
                        <h1>언론보도 수정</h1>
                        <button onClick={handleCancel} className={styles.backBtn}>
                            목록으로
                        </button>
                    </div>
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        데이터를 불러오는 중...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.noticeWrap}>
            <div className={styles.SubPageWidth}>
                <div className={styles.header}>
                    <h1>{id ? "언론보도 수정" : "언론보도 등록"}</h1>
                    <button onClick={handleCancel} className={styles.backBtn}>
                        목록으로
                    </button>
                </div>
                
                <PressForm 
                    item={pressData} // 실제 언론보도 데이터 전달
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                />
            </div>
        </div>
    );
}